import React, { useState, useEffect } from 'react';

import { connect } from 'react-redux';

import { saveAs } from 'file-saver';
import _ from 'lodash';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

import SwaggerUi from 'swagger-ui-react';

import cognitoData from '../../awsConfig';
import AuthHeadersSelector from './AuthHeadersSelector';
import 'swagger-ui-react/swagger-ui.css';
import classes from './DocsPage.module.css';

import { fetchSwaggerDocumentation } from '../../actions/coreActions';

const updateSpec = (spec, cognitoData) => {
    spec.host = cognitoData.key2act.applications.swagger.host;
    return spec;
};

const downloadDoc = (doc) => {
    const blob = new Blob([JSON.stringify(doc)], { type: 'application/json' });
    saveAs(blob, 'swagger.json');
};

export const updateRequest = (request, config) => {
    if (config.token) {
        // by spec, the headers are case incensitive
        let key = _.findKey(request.headers, (val, key) => key.toLowerCase() === 'authorization');
        key = key || 'authorization';
        request.headers[key] = config.token;
    }

    request.headers = {
        ...request.headers,
        ...config.companyId && {'K2A-Company': config.companyId},
    };

    return request;
};

export const toggleSchemeContainer = displayVal => {
    const el = document.getElementsByClassName('scheme-container')[0];
    if (!el) return;
    el.style.display = displayVal;
};

const DocsPage = ({ fetchSwaggerDocumentation }) => {
    const [headers, setHeaders] = useState({});
    const [spec, setSpec] = useState({});
    const [doc, setDoc] = useState({});

    useEffect(() => {
        const init = async () => {
            const { token } = headers;

            const doc = await fetchSwaggerDocumentation();
            setDoc(doc);
            setSpec(doc);

            toggleSchemeContainer(_.isEmpty(token) ? 'block' : 'none');
        };

        init();

    }, [headers]);

    const handleAuthChange = config => setHeaders(config);
    const requestInterceptor = req => updateRequest(req, headers);

    if (_.isEmpty(spec)) return null;

    return (
        <Paper className={classes.DocsPage}>
            <AuthHeadersSelector handleAuthChange={handleAuthChange} />
            <Button
                className={classes.Download}
                onClick={() => downloadDoc(doc)}
            >
                Download
            </Button>
            <SwaggerUi spec={updateSpec(spec, cognitoData)} requestInterceptor={requestInterceptor} />
        </Paper>
    );
};

const mapDispatchToProps = {
    fetchSwaggerDocumentation
};

export default connect(null, mapDispatchToProps)(DocsPage);
